package fr.manyverse.app.presentation.components.soundboard

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.ReadOnlyComposable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.luminance
import fr.manyverse.app.domain.model.SoundTag

data class SoundTagPalette(val container: Color, val label: Color)

@Composable
@ReadOnlyComposable
fun soundTagPalette(tag: SoundTag): SoundTagPalette {
    val isLight = MaterialTheme.colorScheme.surface.luminance() > 0.5f
    return when (tag) {
        SoundTag.CALM ->
            if (isLight) SoundTagPalette(Color(0xFFD6DDE5), Color(0xFF1A2330))
            else SoundTagPalette(Color(0xFF2C3440), Color(0xFFCDD6E0))
        SoundTag.TENSION ->
            if (isLight) SoundTagPalette(Color(0xFFFFE7B3), Color(0xFF5C4400))
            else SoundTagPalette(Color(0xFF3D2E00), Color(0xFFFFB300))
        SoundTag.COMBAT ->
            if (isLight) SoundTagPalette(Color(0xFFFFD5D5), Color(0xFF6B0F0F))
            else SoundTagPalette(Color(0xFF3D0A0A), Color(0xFFFF6B6B))
    }
}
